import React, { useEffect } from "react";
import { Prompt } from "react-router-dom";

export const AI_ASSISTANT_UNSAVED_CHANGES_MESSAGE = "עוזר ה-AI עדכן את הטופס והשינויים עדיין לא נשמרו. לצאת בלי לשמור?";

export default function AiAssistantUnsavedChangesPrompt({ when }) {
  useEffect(() => {
    if (!when) return undefined;
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = "";
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [when]);

  return <Prompt when={when} message={AI_ASSISTANT_UNSAVED_CHANGES_MESSAGE} />;
}
